/* eslint-disable no-console */
import Annotation from '@zxy-cloud/react-image-annotation';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { appContext } from './components/appContext';
import { EditPanelDatePicker, EditPanelFilterCreateSelect, SmallFilterSelect, TableRowActions } from './components/elements';
import { WaveformChart } from './components/Surveys/Common/WaveformChart';
import { GenericMap } from './components/utils/GenericMap';
import { PieChart } from './components/utils/PieChart';
import { TimelineChart } from './components/utils/TimelineChart';
import { Roles } from './utils/enums/Roles';
import { GlobalSettings } from './utils/getGlobalSettings';

const waveform = {
    measuredDateTime: '2019-02-25T09:49:13.1868208Z',
    data: [
        3, 10, 11, 3, 0, 0, 0, 0, 7, 10, 5, 0, 0, 1, 8, 11, 7, 0, 0, 0, 0, 0, 5, 6, 1, 0, 0, 0, 2, 2, 0, 0, 2, 6, 6, 2, 0, 0, 0, 0, 0, 1, 3, 2, 0, 0,
        0, 0, 5, 9, 7, 5, 5, 6, 2, 0, 0, 0, 0, 5, 8, 4, 0, 0, 0, 0, 4, 8, 8, 2, 0, 0, 0, 2, 2, 0, 0, 0, 0, 3, 5, 5, 5, 4, 2, 0, 0, 0, 0, 0, 5, 6, 4,
        2, 3, 4, 1, 0, 0, 0, 0, 11, 12, 2, 0, 0, 0, 1, 0, 0, 0, 2, 8, 6, 0, 0, 0, 4, 7, 3, 0, 0, 0, 0, 1, 0, 0, 0, 1, 3, 3, 2, 0, 0, 0, 0, 0, 1, 11,
        17, 15, 5, 0, 2, 20, 28, 8, 0, 0, 0, 0, 0, 0, 0, 0, 30, 19, 0, 110, 493, 926, 947, 239, 0, 0, 0, 0, 523, 1683, 1923, 1276, 236, 0, 0, 0, 0,
        130, 397, 397, 198, 0, 0, 0, 0, 38, 0, 0, 0, 0, 79, 877, 1369, 1175, 360, 0, 0, 0, 0, 6, 416, 509, 355, 111, 0, 0, 0, 12, 92, 105, 62, 0, 0,
        0, 0, 0, 0, 12, 10, 0, 0, 0, 0, 0, 0, 0, 0, 3, 10, 12, 23, 53, 90, 94, 32, 0, 0, 0, 0, 11, 129, 170, 132, 54, 0, 0, 0, 0, 0, 17, 18, 4, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 12, 86, 134, 122, 51, 0, 0, 0, 0, 0, 11, 28, 26, 17, 7, 4, 6, 11, 15, 14, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 6, 7, 7, 9,
        8, 4, 0, 0, 0, 0, 0, 0, 0, 12, 40, 50, 30, 0, 0, 0, 0, 5, 16, 9, 0, 0, 0, 0, 0, 0, 0, 21, 25, 70, 237, 486, 607, 349, 0, 0, 0, 0, 0, 900,
        1447, 1282, 588, 0, 0, 0, 0, 0, 224, 342, 264, 80, 0, 0, 0, 0, 0, 0, 0, 0, 0, 381, 825, 912, 521, 0, 0, 0, 0, 0, 222, 422, 381, 201, 12, 0, 0,
        0, 40, 78, 62, 11, 0, 0, 0, 0, 0, 0, 4, 7, 11, 14, 14, 7, 0, 0, 0, 8, 18, 23, 29, 35, 30, 0, 0, 0, 0, 0, 0, 116, 186, 178, 102, 1, 0, 0, 0, 0,
        1, 33, 37, 19, 0, 0, 0, 0, 0, 0, 0, 0, 18, 57, 90, 88, 41, 0, 0, 0, 0, 0, 30, 63, 61, 35, 8, 0, 0, 0, 0, 4, 4, 1, 0, 0, 0, 0, 0, 0, 0, 8, 15,
        16, 10, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 22, 70, 98, 87, 37, 0, 0, 0, 0, 0, 35, 80, 79, 40, 0, 0, 0, 0, 0, 0, 0, 0, 3, 37, 144, 313, 430, 335,
        0, 0, 0, 0, 0, 258, 750, 847, 563, 113, 0, 0, 0, 0, 117, 174, 104, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 95, 422, 608, 517, 181, 0, 0, 0, 0, 0, 118,
        153, 99, 25, 0, 0, 8, 24, 22, 9, 0, 2, 19, 36, 38, 20, 0, 0, 0, 0, 0, 0, 6, 12, 10, 5, 2, 3, 10, 14, 12, 1, 0, 0, 0, 0, 0, 20, 41, 49, 33, 0,
        0, 0, 0, 0, 24, 36, 27, 7, 0, 0, 0, 0, 0, 0, 0, 1, 9, 17, 29, 40, 40, 21, 0, 0, 0, 0, 0, 27, 34, 19, 0, 0, 0, 0, 0, 11, 30, 39, 33, 15, 0, 0,
        0, 0, 0, 5, 13, 13, 7, 0, 0, 0, 0, 0, 0, 1, 7, 8, 4, 0, 5, 23, 44, 52, 32, 0, 0, 0, 0, 0, 25, 64, 69, 43, 5, 0, 0, 0, 0, 0, 0, 4, 4, 1, 14,
        68, 167, 262, 258, 78, 0, 0, 0, 0, 0, 418, 690, 650, 364, 9, 0, 0, 0, 0, 17, 72, 56, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 225, 424, 462, 291, 0, 0,
        0, 0, 0, 3, 142, 178, 134, 58, 0, 0, 0, 0, 10, 38, 57, 60, 40, 1, 0, 0, 0, 0, 0, 6, 8, 5, 2, 0, 0, 0, 7, 15, 20, 19, 13, 6, 0, 0, 0, 0, 0, 0,
        14, 41, 50, 40, 21, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 31, 55, 62, 42, 3, 0, 0, 0, 0, 0, 0, 2, 3, 3, 6, 16, 32, 48, 54, 39, 5, 0,
        0, 0, 0, 0, 21, 38, 35, 19, 0, 0, 0, 0, 10, 21, 17, 2, 0, 0, 0, 0, 0, 1, 6, 16, 23, 19, 3, 0, 0, 0, 0, 0, 12, 24, 25, 15, 0, 0, 0, 0, 0, 0, 0,
        0, 9, 43, 100, 164, 190, 124, 0, 0, 0, 0, 0, 103, 415, 543, 441, 187, 0, 0, 0, 0, 0, 39, 65, 39, 0, 0, 0, 0, 0, 0, 0, 0, 0, 62, 226, 337, 313,
        142, 0, 0, 0, 0, 0, 56, 136, 134, 84, 25, 0, 0, 0, 0, 25, 41, 39, 22, 1, 0, 0, 0, 0, 0, 0, 0, 0, 12, 13, 7, 4, 8, 13, 14, 10, 8, 7, 1, 0, 0,
        0, 0, 0, 24, 42, 43, 30, 11, 0, 0, 0, 0, 0, 3, 13, 15, 13, 5, 0, 0, 0, 0, 0, 9, 28, 40, 40, 26, 1, 0, 0, 0, 0, 0, 0, 11, 17, 17, 13, 9, 10,
        16, 20, 14, 0, 0, 0, 0, 0, 7, 34, 44, 33, 9, 0, 0, 0, 0, 0, 0, 5, 10, 12, 7, 0, 0, 0, 0, 3, 17, 27, 27, 15, 0, 0, 0, 0, 0, 6, 22, 25, 18, 6,
        0, 0,
    ],
    gate1Amp: 98.290184,
    gate1Tof: 10.74,
    gate2Amp: 70.8842239,
    gate2Tof: 14.16,
    gate3Amp: 0,
    gate3Tof: 0.02,
    adGain: 35,
    adDelay: 7.43016958,
    adWidth: 19.8589821,
    prMode: 1,
    prPrf: 500,
    prVoltage: 150,
    prWidth: 0.5,
    digitizerSamplingRate: 1,
    adFilterMode: 2,
    adAveraging: 1,
    useGate1: true,
    gate1Start: 7.43016958,
    gate1Width: 100,
    gate1Threshold: 80,
    gate1Mode: 3,
    useGate2: true,
    gate2Start: 11.74,
    gate2Width: 50,
    gate2Threshold: 40,
    gate2Mode: 3,
    isConnected: true,
    positionX: 10,
    positionY: 20,
    positionZ: 30,
    rectify: 1,
};

export function ValidateControls(props: { globalSettings: GlobalSettings }) {
    return (
        <BrowserRouter>
            <appContext.Provider
                value={{
                    languageCode: 'en',
                    userRole: Roles.Administrator,
                    isClient: false,
                    isDroneOperator: false,
                    companyId: 'companyId',
                    userId: 'userId',
                    globalSettings: props.globalSettings,
                }}
            >
                <div>
                    <div>
                        <SmallFilterSelect
                            name="name"
                            value="id"
                            handleChange={() => console.log('change')}
                            topLabel="top label"
                            placeholder="placeholder"
                            options={[{ text: 'text', value: 'id' }]}
                        />
                    </div>
                    <div>
                        <EditPanelFilterCreateSelect
                            name="name"
                            value={['id']}
                            placeholder="placeholder"
                            options={['id']}
                            handleChange={() => console.log('change')}
                        />
                    </div>
                    <div>
                        <EditPanelDatePicker
                            name="from"
                            value="2020-23-03"
                            handleChange={() => console.log('change')}
                            topLabel="top label"
                            placeholder="placeholder"
                        />
                    </div>
                    <div>
                        <TableRowActions actions={[{ text: 'text', onClick: () => console.log('click') }]} />
                    </div>
                    <div>
                        <GenericMap
                            mapLoaded={() => console.log('loaded')}
                            zoom={1}
                            center={{ lat: 50, lng: 52 }}
                            isPdokMapLayerAvailable={false}
                            isDroneNoFlyMapNlAvailable={false}
                            markers={[
                                {
                                    key: 'id',
                                    position: { lat: 50, lng: 52 },
                                    title: 'title',
                                    onClick: () => console.log('click'),
                                    color: 'red',
                                },
                            ]}
                        />
                    </div>

                    <div style={{ width: '200px' }}>
                        <PieChart
                            data={[
                                { id: '1', factor: 0.25, title: '25', color: 'red' },
                                { id: '2', factor: 0.75, title: '3/4' },
                            ]}
                            onClick={() => console.log('click')}
                        />
                    </div>
                    <div style={{ width: '200px' }}>
                        <WaveformChart waveFormResult={waveform} onSelectPoint={(point) => console.log('point', point)} />
                    </div>

                    <div>
                        <TimelineChart
                            data={[
                                { title: 'one', tooltipBodyText: 'ONE', startDate: '2000-01-01', endDate: '2001-01-01' },
                                {
                                    title: 'two',
                                    tooltipBodyText: 'TWO',
                                    startDate: '2010-01-01',
                                    endDate: '2011-01-01',
                                    backgroundColor: 'green',
                                    url: 'url',
                                },
                            ]}
                        />
                    </div>

                    <div style={{ width: '200px' }} className="annotationDiv">
                        <Annotation
                            src={`/assets/img/zxy/logos/logo-small.png`}
                            style={{ imageOrientation: 'from-image' }}
                            annotations={[]}
                            disableAnnotation={false}
                            value={{}}
                            renderOverlay={() => <div />}
                        />
                    </div>
                </div>
            </appContext.Provider>
        </BrowserRouter>
    );
}
